import { Patient } from '../patient/patient';
import { ExamTemplate } from '../exam-template/exam-template';

export class ExamRequest {
  constructor(
    public id?: number,
    public date?: Date,
    public root_cause?: string,
    public exam_templates?: ExamTemplate[],
    public patient?: Patient
  ) {}
}
